import { makeAppStyles } from '@percept/mui'

export const useCompactTableCellClasses = makeAppStyles((theme) => ({
  tableCell: {
    ...theme.appComponents.performanceTable.cellCompact,
  },
}))
